<div class="container-fluid" id="contactSales">
  <form (ngSubmit)="onSave()" [formGroup]="contactSalesFormGroup" class="needs-validation" novalidate>
    <h1 id="pageHeader">Contact Sales</h1>
    <div *ngIf="!(busy$ | async)">
      <p>
        Thank you for exploring the Precisely portfolio of Data Products. We look forward to helping you find the data
        you need to make decisions with confidence, increase revenue and minimize risk. Please provide your contact
        information and a data specialist will contact you shortly.
      </p>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-8">
              <div class="form-group">
                <label for="comment"
                  >Comments/Questions
                  <span>({{ 255 - comment.value.length }})</span>
                </label>
                <textarea
                  [ngClass]="{ 'is-invalid': comment.isInvalid() }"
                  class="form-control"
                  formControlName="comment"
                  id="comment"
                  maxlength="255"
                  minlength="1"
                  name="comment"
                  required="required"
                ></textarea>
                <div *ngIf="comment.isInvalid()" class="text-danger"><span>Required</span></div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="areaOfInterest">Area of Interest</label>
                <select
                  [ngClass]="{ 'is-invalid': areaOfInterest.isInvalid() }"
                  class="form-control input-sm"
                  formControlName="areaOfInterest"
                  id="areaOfInterest"
                  name="areaOfInterest"
                  required
                >
                  <option value="">- Select -</option>
                  <option *ngFor="let areaOfInterest of areasOfInterest$ | async" value="{{ areaOfInterest }}">
                    {{ areaOfInterest }}
                  </option>
                </select>
                <div *ngIf="areaOfInterest.isInvalid()" class="text-danger">Required</div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="reason">Reason</label>
                <select
                  [ngClass]="{ 'is-invalid': reason.isInvalid() }"
                  class="form-control input-sm"
                  formControlName="reason"
                  id="reason"
                  name="reason"
                  required
                >
                  <option value="">- Select -</option>
                  <option *ngFor="let item of contactMeNowReasons$ | async" value="{{ item }}">{{ item }}</option>
                </select>
                <div *ngIf="reason.isInvalid()" class="text-danger">Required</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="email">Email</label>
                <input
                  class="form-control input-sm"
                  formControlName="email"
                  id="email"
                  maxlength="80"
                  minlength="0"
                  name="email"
                  required
                  type="email"
                />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="firstName">First Name</label>
                <input
                  class="form-control input-sm"
                  formControlName="firstName"
                  id="firstName"
                  maxlength="40"
                  minlength="0"
                  name="firstName"
                  required
                  type="text"
                />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="lastName">Last Name</label>
                <input
                  class="form-control input-sm"
                  formControlName="lastName"
                  id="lastName"
                  maxlength="40"
                  minlength="0"
                  name="lastName"
                  required
                  type="text"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="companyName">Company Name</label>
                <input
                  class="form-control input-sm"
                  formControlName="companyName"
                  id="companyName"
                  name="companyName"
                  required
                  type="text"
                />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="industry">Industry</label>
                <select
                  [ngClass]="{ 'is-invalid': industry.isInvalid() }"
                  class="form-control input-sm"
                  formControlName="industry"
                  id="industry"
                  name="vertical"
                  required
                >
                  <option value="">- Select -</option>
                  <option *ngFor="let industry of industries$ | async" value="{{ industry }}">{{ industry }}</option>
                </select>
                <div *ngIf="industry.isInvalid()" class="text-danger">Required</div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="jobTitle">Job Title </label>
                <input
                  [ngClass]="{ 'is-invalid': jobTitle.isInvalid() }"
                  class="form-control input-sm"
                  formControlName="jobTitle"
                  id="jobTitle"
                  maxlength="64"
                  minlength="0"
                  name="title"
                  required
                  type="text"
                />
                <div *ngIf="jobTitle.isInvalid()" class="text-danger">Required</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="country">Country</label>
                <select
                  (change)="onCountryChange()"
                  [ngClass]="{ 'is-invalid': country.isInvalid() }"
                  class="form-control input-sm"
                  formControlName="country"
                  id="country"
                  name="country"
                  required
                >
                  <option [ngValue]="">- Select -</option>
                  <option *ngFor="let country of countries$ | async" [ngValue]="country">{{ country.name }}</option>
                </select>
                <div *ngIf="country.isInvalid()" class="text-error">Required</div>
              </div>
            </div>
            <div *ngIf="country.value && country.value.states && country.value.states.length > 0" class="col-sm-4">
              <div class="form-group">
                <label for="state">State/Province</label>
                <select
                  [ngClass]="{ 'is-invalid': stateOrProvince.isInvalid() }"
                  class="form-control input-sm"
                  formControlName="stateOrProvince"
                  id="state"
                  name="stateOrProvince"
                  required
                >
                  <option value="">- Select -</option>
                  <option *ngFor="let state of country.value.states" ngValue="state">{{ state.name }}</option>
                </select>
                <div *ngIf="stateOrProvince.isInvalid()" class="text-danger">Required</div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="phone">Work Phone</label>
                <input
                  [ngClass]="{ 'is-invalid': phone.isInvalid() }"
                  class="form-control input-sm"
                  formControlName="phone"
                  id="phone"
                  maxlength="16"
                  minlength="10"
                  name="phone"
                  required
                  type="text"
                />
                <div *ngIf="phone.isInvalid()" class="text-danger">Enter a valid phone number.</div>
              </div>
            </div>
          </div>

          <p>
            Precisely may share your information with its Partners. These Partners may execute outbound telemarketing
            campaigns in order to promote product and services, or promote Precisely managed events or roadshows on our
            behalf. By submitting this form, you are consenting to being kept informed about new products and services
            that may of interest to you. In some instances, you may receive emails sent by third parties acting on our
            behalf. See our <a href="https://www.precisely.com/legal/privacy-policy" target="_blank">Privacy Policy</a>
            for more details or to opt-out at any time.
          </p>

          <div class="my-6">
            <re-captcha
              *appIfFeature="'google_recaptcha_v2'"
              formControlName="recaptchaReactive"
              (resolved)="onCaptchaResolved($event)"
              [siteKey]="GOOGLE_RECAPTCHA_SITE_KEY"
              (error)="onCaptchaError($event)"
              errorMode="handled"
            ></re-captcha>
          </div>

          <!-- add class to get proper space above buttons -->
          <div class="form-buttons">
            <button
              id="cancel"
              (click)="onCancel()"
              [angularticsProperties]="angularTicsRequest"
              angulartics2On="click"
              angularticsAction="contactsales-cancel"
              angularticsCategory="contactsales"
              class="btn btn-secondary"
              type="button"
            >
              Cancel
            </button>
            <button
              id="submit"
              [angularticsProperties]="angularTicsRequest"
              [disabled]="(saveBusy$ | async) || isDisabled"
              angulartics2On="click"
              angularticsAction="contactsales-submit"
              angularticsCategory="contactsales"
              class="btn btn-primary"
              type="submit"
            >
              <span *ngIf="saveBusy$ | async"> <i class="pbi-icon-mini pbi-loader-circle spin"></i> Submit </span>
              <span *ngIf="!(saveBusy$ | async)"> Submit </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="mb-7"></div>
    </div>
  </form>
</div>
